import React from "react"
import "./earningsPartner.scss"

const EarningsPartner = () => {
  return (
    <section className="earnings-partner">
      <div className="earnings-partner__container">
        <h2 className="earnings-partner__heading">
          Earn More as a <span>Cab Driver</span>
        </h2>
        <p className="earnings-partner__desc">
          See why thousands of drivers are switching to Pulpit
        </p>

        <div className="earnings-partner__layout">
          {/* Left: Ride Receipt Mockup */}
          <div className="earnings-partner__receipt-wrap">
            <div className="earnings-partner__receipt">
              <div className="earnings-partner__receipt-header">
                <span className="earnings-partner__receipt-badge">Ride Completed</span>
                <span className="earnings-partner__receipt-id">#PLP-48291</span>
              </div>

              <div className="earnings-partner__receipt-route">
                <div className="earnings-partner__receipt-dot earnings-partner__receipt-dot--start" />
                <div className="earnings-partner__receipt-line-v" />
                <div className="earnings-partner__receipt-dot earnings-partner__receipt-dot--end" />
                <div className="earnings-partner__receipt-places">
                  <span>Mumbai</span>
                  <span>Pune (Outstation)</span>
                </div>
              </div>

              <div className="earnings-partner__receipt-meta">
                <span>Sedan &bull; 150 km &bull; One Way</span>
              </div>

              <div className="earnings-partner__receipt-divider" />

              <div className="earnings-partner__receipt-rows">
                <div className="earnings-partner__receipt-row">
                  <span>Base fare</span>
                  <span>₹3,200.00</span>
                </div>
                <div className="earnings-partner__receipt-row">
                  <span>Toll (pass-through)</span>
                  <span>₹350.00</span>
                </div>
                <div className="earnings-partner__receipt-row earnings-partner__receipt-row--highlight">
                  <span>Platform fee</span>
                  <span className="earnings-partner__receipt-zero">As per tier</span>
                </div>
              </div>

              <div className="earnings-partner__receipt-divider" />

              <div className="earnings-partner__receipt-total">
                <span>Partner Earns</span>
                <span>₹2,560+</span>
              </div>

              <div className="earnings-partner__receipt-footer">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#21A5A0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Toll passed through at actuals - no extra deduction
              </div>
            </div>

            {/* Route examples strip */}
            <div className="earnings-partner__routes">
              <span className="earnings-partner__routes-label">Popular outstation routes</span>
              <div className="earnings-partner__route-chips">
                <span>Delhi → Agra ₹3,200</span>
                <span>Lucknow → Varanasi ₹5,500</span>
                <span>Jaipur → Delhi ₹6,000</span>
              </div>
            </div>
          </div>

          {/* Right: Benefit Cards */}
          <div className="earnings-partner__benefits">
            <div className="earnings-partner__benefit">
              <div className="earnings-partner__benefit-icon earnings-partner__benefit-icon--teal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div>
                <h4 className="earnings-partner__benefit-title">Pulpit Brings the Customers</h4>
                <p className="earnings-partner__benefit-desc">
                  No spending on marketing or customer acquisition. Pulpit handles all bookings via app and website - you just run the trip.
                </p>
              </div>
            </div>

            <div className="earnings-partner__benefit">
              <div className="earnings-partner__benefit-icon earnings-partner__benefit-icon--orange">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
                </svg>
              </div>
              <div>
                <h4 className="earnings-partner__benefit-title">Weekly Payouts to Bank</h4>
                <p className="earnings-partner__benefit-desc">
                  Completed trips settled every Tuesday via NEFT/IMPS. Full payout statement emailed and available on your Partner Dashboard.
                </p>
              </div>
            </div>

            <div className="earnings-partner__benefit">
              <div className="earnings-partner__benefit-icon earnings-partner__benefit-icon--teal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="12" y1="20" x2="12" y2="10" /><polyline points="18 14 12 8 6 14" /><line x1="4" y1="20" x2="20" y2="20" />
                </svg>
              </div>
              <div>
                <h4 className="earnings-partner__benefit-title">Performance Incentives</h4>
                <p className="earnings-partner__benefit-desc">
                  Maintain 90%+ acceptance rate for better incentives. 50+ trips/month unlocks additional volume bonuses. Festival surge means higher fares for you.
                </p>
              </div>
            </div>

            <div className="earnings-partner__benefit">
              <div className="earnings-partner__benefit-icon earnings-partner__benefit-icon--orange">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <div>
                <h4 className="earnings-partner__benefit-title">Toll &amp; Parking Pass-Through</h4>
                <p className="earnings-partner__benefit-desc">
                  Toll and parking charges are collected from the customer at actuals and transferred to you in full - no extra deduction on these amounts.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EarningsPartner
